import Image from 'app/Components/Shared/Image/image';
import React, {useState, Fragment, useEffect} from 'react';
import {isMobile} from 'react-device-detect';
import {connect} from 'react-redux';
import {recaptcha} from '../../../../utilities/recaptcha/recaptcha';

import {Col, Row, Button} from 'reactstrap';
import {changeHandler, uploadFileForValidation, validateHandler, removeFile} from './bankPaymentSlice';
import images from './images/images';
import ProgressBar from '../../../Shared/ProgressBar/progressBar';
import gaParams from '../../../../utilities/analytics/constants';
import {gaEvent} from '../../../../utilities/analytics/tracking';

const BankComponent = (props) => {
  useEffect(() => {
    if (props.onSubmit && props.onSubmit == true) {
      props.validateHandler(props.bank.form);
    }
  }, [props.onSubmit]);

  //uploading progressBar animation
  useEffect(() => {
    if (props.bank.form.file.trim() == '') {
      setPercent('0');
    }
  }, [props.bank.form.file]);

  useEffect(() => {
    if (props.bank.form.validatedFileName.trim() != '') {
      setPercent('100');
    }
  }, [props.bank.form.validatedFileName]);

  const reader = new FileReader();
  const [percent, setPercent] = useState('0');
  const [error, setError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  async function startUploading(e) {
    let imageFrom = 'upload_file';
    if (e.currentTarget.attributes['capture']) {
      imageFrom = 'camera';
    }
    gaEvent(
      gaParams.UPDATE_PAYMENT_METHOD_CLICK_UPLOAD_IMAGE.category,
      gaParams.UPDATE_PAYMENT_METHOD_CLICK_UPLOAD_IMAGE.eventType,
      imageFrom,
    );
    setError(false);
    const file = e.target.files[0];
    const extension = file.type.split('/')[1];
    const followUpExtType = extension == 'jpeg' ? 'jpg' : extension;
    const validFileSizeAndExtension = await validateFile(e);
    if (validFileSizeAndExtension.payload.valid) {
      let converted = await toBase64(file);
      converted = converted.replace(`data:${file.type};base64,`, '');

      //captcha validation
      recaptcha().then(async (token) => {
        if (token != '' && token != null) {
          uploadFile(followUpExtType, converted, token);
        } else {
          gaEvent(
            gaParams.UPDATE_PAYMENT_METHOD_SHOW_FORM_ERROR.category,
            gaParams.UPDATE_PAYMENT_METHOD_SHOW_FORM_ERROR.eventType,
            gaParams.UPDATE_PAYMENT_METHOD_SHOW_FORM_ERROR.eventParams,
          );
          setError(true);
        }
      });
    } else {
      gaEvent(
        gaParams.UPDATE_PAYMENT_METHOD_SHOW_FORM_ERROR.category,
        gaParams.UPDATE_PAYMENT_METHOD_SHOW_FORM_ERROR.eventType,
        gaParams.UPDATE_PAYMENT_METHOD_SHOW_FORM_ERROR.eventParams,
      );
      setError(true);
    }
  }

  async function validateFile(e) {
    return await props.changeHandler({target: e.target, form: props.bank.form});
  }

  async function uploadFile(extension, converted, token) {
    setError(false);
    setPercent('0');
    setIsLoading(true);

    let i = 0;
    const timer = setInterval(function () {
      setPercent((percent) => +percent + 5);
      i++;
      if (i == 17) {
        clearInterval(timer);
      }
    }, 200);

    const consumerId = props.contactId;
    await props.uploadFileForValidation({extension, converted, token, consumerId});

    setIsLoading(false);
  }

  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const clearData = () => {
    props.removeFile();
    setError(false);
    document.getElementById('attach').value = '';
  };

  return (
    <Fragment>
      <div className={`${isMobile ? 'isMobile' : ''}`}>
        <Row>
          <Col>
            <p className='bold'> העלאת טופס הוראת קבע </p>
          </Col>
        </Row>
        <Row>
          <Col>
            <p>
              <span className='d-block'>לפני שאתם מעלים את הטופס, וודאו שהוא חתום על ידי הבנק</span>
            </p>
          </Col>
        </Row>
        <Row className='text-center'>
          {isMobile && (
            <Col xs={6} className='upload-file-icon-wrapper m-auto'>
              <input
                type='file'
                name='file'
                accept='image/*'
                capture='camera'
                id='tale-photo'
                className='attach-photo'
                onChange={(e) => startUploading(e)}
              />
              <label htmlFor='tale-photo' className='pink'>
                <Image src={images.camera} alt='camera' />
                <span className='d-block bold'>צילום תמונה</span>
              </label>
            </Col>
          )}
          <Col xs={6} className='upload-file-icon-wrapper m-auto'>
            <input type='file' name='file' accept='image/*' id='attach' className='attach-photo' onChange={(e) => startUploading(e)} />
            <label htmlFor='attach' className='pink'>
              <Image src={images.attach} alt='attach' />
              <span className='d-block bold'>בחירת קובץ</span>
            </label>
          </Col>
        </Row>
        <Row>
          <Col>
            <p className={`${props.bank.error || props.bank.form.valid === false || error ? 'error' : ''} mb-0 upload-file-description`}>
              <span className='d-block'>הקובץ צריך להיות בפורמט pdf, tiff, jpg או doc ועד 10 מגה</span>
            </p>
          </Col>
        </Row>
        {(isLoading || props.bank.form.file.trim() != '') && (
          <Row>
            <Col xs={11} className='pl-0 uploading-progress'>
              <div className='progress-bar'>
                <div className='progress-bar-wrapper'>
                  <ProgressBar percent={percent} points={[0]} />
                </div>
              </div>
              {!isLoading ? (
                <span className='file-name'>{props.bank.form.file.split('\\').pop()}</span>
              ) : (
                <span className='file-name'>מעלה קובץ...</span>
              )}
            </Col>
            <Col xs={1} className='pr-0'>
              <Button color='link' className='pr-0' onClick={() => clearData()}>
                <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'>
                  <g fill='none' fillRule='evenodd'>
                    <g>
                      <path d='M0 0L24 0 24 24 0 24z' />
                      <path
                        fill='var(--theme-primary, #810ea9)'
                        fillRule='nonzero'
                        d='M17 6h5v2h-2v13c0 .552-.448 1-1 1H5c-.552 0-1-.448-1-1V8H2V6h5V3c0-.552.448-1 1-1h8c.552 0 1 .448 1 1v3zm1 2H6v12h12V8zm-4.586 6l1.768 1.768-1.414 1.414L12 15.414l-1.768 1.768-1.414-1.414L10.586 14l-1.768-1.768 1.414-1.414L12 12.586l1.768-1.768 1.414 1.414L13.414 14zM9 4v2h6V4H9z'
                      />
                    </g>
                  </g>
                </svg>
              </Button>
            </Col>
          </Row>
        )}
      </div>
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {bank: state.BankPayment};
};

const mapDispatchToProps = {
  changeHandler,
  validateHandler,
  uploadFileForValidation,
  removeFile,
};

export default connect(mapStateToProps, mapDispatchToProps)(BankComponent);
